module.exports = __webpack_public_path__ + "img/created_mind.285d718b.svg";